import axios, { AxiosError } from 'axios';
import toast from 'react-hot-toast';

import store, { resetStore } from '../redux/store';
import { ACCOUNT, SIGNIN } from '../routes/routeConstants';

const errorInterceptor = () =>
  axios.interceptors.response.use(
    (response) => response,
    async (err: AxiosError) => {
      if (
        err.response?.status === 401 &&
        !window.location.href.includes('account')
      ) {
        toast.error('Session has expired');

        // Reset entire Redux store globally
        store.dispatch(resetStore());

        localStorage.removeItem('authData');

        // Navigate to signin instead of reloading the entire page
        window.location.href = `/${ACCOUNT}/${SIGNIN}`;
      }
      return Promise.reject(err);
    }
  );

export default errorInterceptor;
